import { Prismic, PrismicLink } from '@landsbankinn/prismic';
import { Appstore, PlayStore, Segment, SvgButton } from '@landsbankinn/ui';
import React from 'react';
import { DownloadLinks } from '../components/slices/DownloadLinks';

interface IProps {
  app_store: Prismic.Link;
  google_play: Prismic.Link;
  apple_link_text: Prismic.RichText;
  google_link_text: Prismic.RichText;
}

export const DownloadLinksContainer = ({
  app_store,
  google_play,
  apple_link_text,
  google_link_text,
}: IProps) => {
  const appleLinkText = Prismic.text(apple_link_text);
  const appstore = app_store ? (
    <PrismicLink value={app_store} title={appleLinkText ?? undefined}>
      <SvgButton title={appleLinkText ?? ''} target="_blank">
        <Appstore />
      </SvgButton>
    </PrismicLink>
  ) : null;

  const googleLinkText = Prismic.text(google_link_text);
  const googlePlay = google_play ? (
    <PrismicLink value={google_play} title={googleLinkText ?? undefined}>
      <SvgButton title={googleLinkText ?? ''} target="_blank">
        <PlayStore />
      </SvgButton>
    </PrismicLink>
  ) : null;

  return (
    <Segment>
      <DownloadLinks>
        {appstore}
        {googlePlay}
      </DownloadLinks>
    </Segment>
  );
};
